<template>
        <div class="step">
            <div class="title"><span>Шаг 3</span>Выберите профиль пациента или создайте новый</div>
            <div class="third-step">
                <div>
                    <MedicalCard @select-medical-card="selectMedicalCard" :user="user"></MedicalCard>
                    <Promocode  @accepted="promocodeAccepted" :user="user"></Promocode>
                    <div class="price-block">
                        <div v-if="price !== null" class="price">
                            Цена:
                            <span v-bind:class="[discount ? 'price-item old-price' : 'price-item']">{{ price.price_without_discount }} руб</span>
                            <span class="discount" v-if="discount">{{ price.price }} руб</span>
                        </div>
                        <button class="pay" v-if="price !== null" @click="onClickButton">{{ needPay ? 'Перейти к оплате':'Перейти к консультации' }}</button>
                        <div v-if="error.exist" class="error">{{ error.message }}</div>
                    </div>
                </div>
            </div>
        </div>   
</template>

<script>
    import Promocode from '../Promocode/Promocode.vue'
    import MedicalCard from '../MedicalCard/MedicalCard.vue'

    import moment from 'moment';
    import _ from 'lodash';

    import './step3.scss'

    const SERVICE_TYPE_PEDIATR = 1;
    const SERVICE_TYPE_THERAPIST = 4;

    const PAYMENT_TYPE_BY_SERVICE_TYPE = {
        1: 'on_duty',
        4: 'on_duty_therapist'
    };

    export default {
        name: 'Step3',
        props: ['attachments', 'user'],
        data() {
            return {
                price: null,
                serviceType: null,
                requestType: null,
                error: {
                    exist: false,
                    message: ''
                },
            };
        },
        methods: {
            setError: function (message) {
                this.error.exist = true;
                this.error.message = message;
            },
            promocodeAccepted() {
                const self = this;

                this.loadPrice().then((price) => {
                    self.price = price;
                })
            },
            selectMedicalCard(data) {
                const self = this;

                this.medicalCardId = data.id;

                const now = moment();
                const birthdayYears = now.diff(moment(data.birthday, "YYYY-MM-DD"), 'years');
                if (birthdayYears > 18) {
                    this.serviceType = SERVICE_TYPE_THERAPIST;
                } else {
                    this.serviceType = SERVICE_TYPE_PEDIATR;
                }

                this.loadPrice().then((price) => {
                    self.price = price;
                })
            },
            loadPrice() {
                const self = this;

                return new Promise((resolve, reject) => {
                    let url = process.env.VUE_APP_HOST + '/mobile/get_price/?' + new URLSearchParams({serviceType: this.serviceType});

                    fetch(url, {
                        headers: new Headers({
                            'Authorization': 'Token ' + self.user.session,
                        }),
                    }).then((response) => {
                        response.json().then(function (data) {
                            if (data.status === 'OK') {
                                resolve({price: parseInt(data.price), balance: data.balance, price_without_discount: data.price_without_discount});
                            } else {
                                self.setError(data.message);
                                reject(data.message);
                            }
                        })
                    }, (response) => {
                        console.error('Возникла неизвестная ошибка', response);
                        self.setError('Возникла неизвестная ошибка');
                    })
                })
            },
            getPaymentLink() {
                const self = this;

                return new Promise((resolve, reject) => {
                    const urlParams =  new URLSearchParams({type: PAYMENT_TYPE_BY_SERVICE_TYPE[self.serviceType], attached_files: _.join(_.map(this.attachments, 'id'), ','), medical_card_id: self.medicalCardId, save_card: false, from_landing: 'laboratory'});

                    let url = process.env.VUE_APP_HOST + '/mobile/user/get_tinkoff_links/?' + urlParams;
                    fetch(url, {
                        headers: new Headers({
                            'Authorization': 'Token ' + self.user.session,
                        }),
                    }).then((response) => {
                        response.json().then(function (data) {
                            if (data.status === 'OK') {
                                resolve(data.data);
                            } else {
                                self.setError(data.message);
                                reject(data);
                            }
                        })
                    }, (response) => {
                        console.error('Возникла неизвестная ошибка', response);
                        self.setError('Возникла неизвестная ошибка');
                    })
                });
            },
            createConsultation() {
                const self = this;

                return new Promise((resolve, reject) => {
                    const formData = new FormData();
                    formData.append('medical_card_id', self.medicalCardId);

                    let url = process.env.VUE_APP_HOST;

                    if (self.serviceType === SERVICE_TYPE_PEDIATR) {
                        url += '/mobile/user/create_on_duty_request/';
                    } else {
                        url += '/mobile/user/create_on_duty_request_therapist/'
                    }

                    fetch(url, {
                        method: 'POST',
                        headers: new Headers({
                            'Authorization': 'Token ' + self.user.session,
                        }),
                        body: formData
                    }).then((response) => {
                        response.json().then(function (data) {
                            if (data.status === 'OK') {
                                resolve(data.request);
                            } else {
                                reject(data);
                                self.setError(data.message);
                            }
                        })
                    }, (response) => {
                        console.error('Возникла неизвестная ошибка', response);
                        self.setError('Возникла неизвестная ошибка');
                    })
                });
            },
            attachFileInConsultation(requestId, files) {
                const self = this;

                return Promise.all(_.each(files, (file) => {
                    return new Promise((resolve, reject) => {

                        const formData = new FormData();
                        formData.append('file_id', file.id);
                        formData.append('request_id', requestId);

                        let url = process.env.VUE_APP_HOST + '/mobile/user/add_request_attachment/';

                        fetch(url, {
                            method: 'POST',
                            headers: new Headers({
                                'Authorization': 'Token ' + self.user.session,
                            }),
                            body: formData
                        }).then((response) => {
                            response.json().then(function (data) {
                                if (data.status === 'OK') {
                                    resolve(data);
                                } else {
                                    reject(data);
                                    self.setError(data.message);
                                }
                            })
                        }, (response) => {
                            console.error('Возникла неизвестная ошибка', response);
                            self.setError('Возникла неизвестная ошибка');
                        })
                    });
                }));
            },
            onClickButton() {
                const self = this;

                if (this.needPay) {
                    this.getPaymentLink().then((data) => {
                        self.$store.commit('setOrder', {id: data.order_id, authToken: self.user.authToken});
                        location.href = data.url;
                    });
                } else {
                    this.createConsultation().then((request) => {
                        self.attachFileInConsultation(request.id, self.attachments).then(() => {
                            location.href = process.env.VUE_APP_HOST + '/history/?request_id=' + request.id + '&open_created_popup=true&auth_token=' + self.user.authToken;
                        }, (error) => {
                            console.error('error', error)
                            self.setError('Возникла неизвестная ошибка');
                        });
                    })
                }
            }
        },
        computed: {
            needPay: function() {
                return !(this.price.price === 0 || this.price.price <= this.price.balance);
            },
            discount: function() {
                return this.price.price !== this.price.price_without_discount;
            }
        },
        components: {
            Promocode,
            MedicalCard
        }
    }
</script>
